import {Action, Module, Mutation, VuexModule} from 'vuex-module-decorators';

import {MemberInterface} from "@/types/Member";

import {Member as MemberUtil} from "@/util/Member";
import {Store} from "@/enums/Store";
import {DiscountCheckInterface} from "@/types/DiscountCheck";


@Module({
  namespaced: true
})
export default class Member extends VuexModule<MemberStateInterface> {
  members: MemberInterface[] = [];

  @Mutation
  PUSH_MEMBER(member: MemberInterface) {
    this.members.push(member)
  }

  @Mutation
  SET_MEMBERS(members: MemberInterface[]) {
    this.members = members
  }

  @Mutation
  SET_MEMBER({member, index}: SetMemberPayloadInterface) {
    this.members.splice(index, 1, member)
  }

  @Mutation
  REMOVE_MEMBER(index: number) {
    this.members.splice(index, 1)
  }

  @Action
  addMember(member: MemberInterface) {
    const {commit} = this.context;

    commit('PUSH_MEMBER', member)
  }

  @Action
  updateMember(member: MemberInterface) {
    const {getters, commit} = this.context;
    const index = getters.memberIndexById(member.id);

    commit('SET_MEMBER', {member, index})
  }

  @Action
  removeMember(member: MemberInterface) {
    const {getters, commit} = this.context;
    const index = getters.memberIndexById(member.id);

    commit('REMOVE_MEMBER', index)
  }

  @Action
  setMemberDiscount(discount: DiscountCheckInterface) {
    const {getters, dispatch} = this.context;
    const member = getters.memberById(discount.memberId)
    if (member){
      if(discount.isAllowed){
        member.discount = discount
      }else{
        member.discount = undefined
      }
      dispatch("updateMember",member);
    }
  }

  @Action
  clearMembers() {
    const {commit} = this.context;
    commit('SET_MEMBERS', []);
  }

  get memberById() {
    return (id: string) => {
      const member = this.members.find((member: MemberInterface) => {
        return member.id == id
      });

      if (!member) {
        return undefined;
      }
      return member
    }
  }

  get isMemberEmailUnique() {
    return (email: string) => {
      const count = this.members.reduce((count:number, member: MemberInterface) => {
        if(member.email && member.email.toLowerCase() == email.toLowerCase()) {
          return count+1
        }

        return count
      }, 0);

      if (count <= 1) {
        return true
      }

      return false
    }
  }

  get memberIndexById() {
    return (id: string) => {
      const index = this.members.findIndex((member: MemberInterface) => {
        return member.id == id
      });

      return index
    }
  }
}

export interface MemberStateInterface {
  members: MemberInterface[]
}

export interface SetMemberPayloadInterface {
  member: MemberInterface
  index: number
}
